export default "__VITE_ASSET__A5jNVrdT__"